/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import React from 'react';

import Svg from 'svg'


export default function (props)
{
  return (
    <Svg data-name="&lt;Layer&gt;" viewBox="0 0 32 32" {...props}><defs/><rect width="32" height="32" className="none"/><g><rect x="3" y="6" width="26" height="20" className="white-shape"/><g data-name="no-invert line-dash-a"><rect x="3" y="6" width="26" height="20" className="black-line-20"/></g></g><polyline points="9.5 14.5 12.1 13 16 19 19.9 13 22.5 14.5" className="black-line-10"/></Svg>
  );
}
